import React, { useState, useEffect, Fragment, useMemo } from 'react'
import { useHistory } from 'react-router';
import { valdiatePage } from '../../global';
import { qsronicreport } from '../../services/reportservice';
import Loader from '../../images/whiteloader.svg';
import { accountsLocations } from '../../services/userservice';
import { setLoading } from '../../redux/appSlice';
import { useDispatch, useSelector } from 'react-redux';
import ExportExcelButton from "../../components/exportExcelButton";
import Pagination from '../../components/paginations';
import SeeMoreModal from '../../components/SeeMoreModal';

export const qsrOnicColumns = [
  { label: "Consignment Number", key: "consignmentNumber" },
  { label: "Account No", key: "accountNo" },
  { label: "Location Name", key: "LocationName" },
  { label: "Booking Date", key: "BookingDate" },
  { label: "Arrival Date", key: "ArrivalDate" },
  { label: "Origin Zone", key: "OrgZone" },
  { label: "Origin Branch", key: "OrgBranch" },
  { label: "Consignee", key: "consignee" },
  { label: "Consignee Phone No", key: "consigneePhoneNo" },
  { label: "Consignee Address", key: "consigneeAddress" },
  { label: "Order Ref No", key: "orderRefNo" },
  { label: "Service", key: "service" },
  { label: "Dest Zone", key: "destzone" },
  { label: "Dest Branch", key: "destbranch" },
  { label: "Weight", key: "weight" },
  { label: "Received By", key: "receivedBy" },
  { label: "Time", key: "time" },
  { label: "Delivery Date", key: "deliveryDate" },
  { label: "COD Amount", key: "CODAmount" },
  { label: "Status", key: "RRStatus" },
  { label: "Terminal Status", key: "NCIReason" },
  { label: "Payment Mode", key: "PaymentMode" },
  { label: "Payment Id", key: "paymentId" },
  { label: "Cheque No", key: "InstrumentNumber" },
  { label: "Total Amount", key: "totalAmount" },
  { label: "GST", key: "GST" },
  { label: "Attempts", key: "Attempts" },
  { label: "MSISDN", key: "MSISDN" },
  { label: "Onic Delivery Date", key: "onic_deliveryDate" },
  { label: "Delivery Type", key: "deliveryType" },
  { label: "Time Slot", key: "timeSlot" },
  { label: "ICCID", key: "ICCID" },
];


const QSR = () => {

    const dispatch = useDispatch();
    const { accounts, loading, userInfo } = useSelector(state => state.appData);

    const now = new Date();
    const today = `${now.getFullYear()}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getDate().toString().padStart(2, '0')}`;
    const month = `${now.getMonth() + 1}`;
    const year = `${now.getFullYear()}`;

    const history = useHistory();

    const [locations, setLocations] = useState([]);

    const d = {
        isMonthWise: false,
        StartDate: today,
        EndDate: today,
        Year: year,
        Month: month,
        locationID: [],
        account: [accounts[0]],
        creditclientid: '',
        dateType: 'BOOKING'
    };
    const [data, setData] = useState(d);
    const [grid, setGrid] = useState([]);
 
    const [page, setPage] = useState(0);
    const [pageLimit, setPageLimit] = useState(50);
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'ascending' });
    const [originalGrid, setOriginalGrid] = useState([]);
    
    const searchObjInit = {
        consignmentNumber: '',
        BookingDate: '',
        orderRefNo: '',
        weight: '',
        totalAmount: '',
        OrgBranch: '',
        consignee: '',
        service: '',
        CODAmount: '',
        destbranch: '',

    };

    const [searchObject, setSearchObj] = useState(searchObjInit);
    const updateSearchData = (key, val) => setSearchObj(prev => { return { ...prev, [key]: val } });
    const gridKeys = [
        {key: 'consignmentNumber', name: 'Consignment', searchBox: true, visible: true},
        {key: 'accountNo', name: 'Account#', searchBox: false, visible: true},
        {key: 'locationName', name: 'Location Name', searchBox: false, visible: true},
        {key: 'BookingDate', name: 'Booking Date', searchBox: true, visible: true},
        {key: 'arrivalDate', name: 'Arrival Date', searchBox: false, visible: true},
        {key: 'OrgZone', name: 'Origin Zone', searchBox: false, visible: true},
        {key: 'OrgBranch', name: 'Origin Branch', searchBox: true, visible: true},
        {key: 'consignee', name: 'Consignee', searchBox: true, visible: true},
        {key: 'consigneePhoneNo', name: 'Consignee Phone No', searchBox: true, visible: true},
        {key: 'consigneeAddress', name: 'Consignee Address', searchBox: true, visible: true},
        {key: 'orderRefNo', name: 'OrderRefNo', searchBox: true, visible: true},
        {key: 'service', name: 'Service', searchBox: true, visible: true},
        {key: 'destzone', name: 'Destination Zone', searchBox: false, visible: true},
        {key: 'destbranch', name: 'Destination Branch', searchBox: true, visible: true},
        {key: 'weight', name: 'Weight', searchBox: true, visible: true},
        {key: 'receivedBy', name: 'Received By', searchBox: false, visible: true},
        {key: 'time', name: 'Time', searchBox: false, visible: true},
        {key: 'deliveryDate', name: 'Delivery Date', searchBox: false, visible: true},
        {key: 'CODAmount', name: 'COD Amount', searchBox: true, visible: true},
        {key: 'RRStatus', name: 'Status', searchBox: false, visible: true},
        {key: 'NCIReason', name: 'Terminal Status', searchBox: false, visible: true},
        {key: 'PaymentMode', name: 'Payment Mode', searchBox: false, visible: true},
        {key: 'paymentId', name: 'Payment Id', searchBox: false, visible: true},
        {key: 'InstrumentNumber', name: 'Cheque No', searchBox: false, visible: true},
        {key: 'totalAmount', name: 'Total Amount', searchBox: true, visible: true},
        {key: 'GST', name: 'GST', searchBox: false, visible: true},
        {key: 'Attempts', name: 'Attempts', searchBox: false, visible: true},
        {key: 'MSISDN', name: 'MSISDN', searchBox: true, visible: true},
        {key: 'onic_deliveryDate', name: 'Onic Delivery Date', searchBox: false, visible: true},
        {key: 'deliveryType', name: 'Sim Type', searchBox: false, visible: true},
        {key: 'timeSlot', name: 'Time Slot', searchBox: false, visible: true},
        {key: 'ICCID', name: 'ICCID', searchBox: false, visible: true}
    ]
    
    const requestSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
          direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    let filterData = useMemo(() => {
        return grid.filter((item, index) => {
            return (index >= page * pageLimit) & (index < (page + 1) * pageLimit);
        })
    }, [page, grid, pageLimit, grid.length]);

    const sortedArray = [...filterData].sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
      });


    useEffect(() => {
        if (!valdiatePage('/qsronicreport')) {
            history.push('/login');
        }
    }, []);

    const updateData = (key, val) => setData(prev => { return { ...prev, [key]: val } });

    const onSearch = async () => {
        if (data.isMonthWise) {
            if (!data.Year) {
                alert('Select Year');
                return;
            }
            if (!data.Month) {
                alert('Select Month');
                return;
            }
        }
        else {
            if (!data.StartDate) {
                alert('Select Start Date');
                return;
            }
            if (!data.EndDate) {
                alert('Select End Date');
                return;
            }
        }

        if (data.account.length == 0) {
            alert('Select Account');
            return;
        }

        if (data.locationID.length == 0) {
            alert('Select Location');
            return;
        }

        dispatch(setLoading({ data: true }));

        var rs = await qsronicreport(data);

        dispatch(setLoading({ data: false }));
        if (rs.sts == 0) {
            if (rs.data.length > 0) {
                let rsData = rs.data.map(e => {
                    const onic_delivery = rs.onic_delivery.find(x => x.consignmentNumber == e.consignmentNumber);
                    return {...e, ...onic_delivery}
                });


                setGrid(rsData);
                setOriginalGrid(rsData);
            } else {
                alert('No Data Found');
                setGrid([]);
            }
        }
        else {
            alert(rs.msg);
            setGrid([]);
        }
    }

    useEffect(() => {
        if (accounts.length > 0) {
            accountsLocations({ uid: userInfo.id, accounts: [accounts[0]] }).then((rs) => {
                const d = { ...data };
                setLocations(rs);
                d.locationID = [+rs[0].value];
                setData(d);
            })
        }
    }, [])

    return userInfo &&
        <section className="section">
            <div className="section-header">
                <h1>QSR ONIC Report</h1>
            </div>
            <div className="card" style={{ padding: 10 }}>
                <div className="row pb-2">
                    <div className="col">
                        <label>Account</label>
                        <select className="form-select" value={data.account} multiple onChange={async (e) => {
                            let value = Array.from(e.target.selectedOptions, option => option.value);
                            const d = { ...data, account: value };
                            if (value && value.length > 0) {
                                const locs = await accountsLocations({ uid: userInfo.id, accounts: value })
                                if (locs && locs.length > 0) {
                                    setLocations(locs);
                                    d.locationID = [+locs[0].value]
                                }
                            } else {
                                setLocations([]);
                            }
                            setData(d);
                        }}>
                            {
                                accounts.map((x, index) => <option key={index} value={x}>{x}</option>)
                            }
                        </select>
                    </div>
                    <div className="col">
                        <label>Location</label>
                        <select className="form-select" multiple value={data.locationID} onChange={async (e) => {
                            let vals = Array.from(e.target.selectedOptions, option => +option.value);
                            setData({ ...data, locationID: vals });

                        }}>
                            {
                                locations.map((x, index) => <option key={index} data-creditclientid={x.creditClientId} value={x.value}>{x.text}</option>)
                            }
                        </select>
                    </div>
                    <div className="col">
                        <div>
                            <label style={{ whiteSpace: 'nowrap' }}>Is Month Wise Report</label><br />
                            <label className="switch">
                                <input type="checkbox" checked={data.isMonthWise} onChange={e => updateData('isMonthWise', e.target.checked)} />
                                <span className="slider round"></span>
                            </label>
                        </div>

                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'start', alignItems: 'center', marginTop: '10px' }}>
                            <div className="form-check">
                                <input className="form-check-input" type="radio" name="type" id="type1" checked={data.dateType == "BOOKING"} onChange={e => {
                                    updateData('dateType', "BOOKING")
                                }} />
                                <label className="form-check-label" htmlFor="type1">BOOKING DATE</label>
                            </div>
                            <div className="form-check" style={{ marginLeft: 10 }}>
                                <input className="form-check-input" type="radio" name="type2" id="type2" checked={data.dateType == "HANDOVER"} onChange={e => {
                                    updateData('dateType', "HANDOVER")
                                }} />
                                <label className="form-check-label" htmlFor="type2">HANDOVER DATE</label>
                            </div>
                             <div className="form-check" style={{ marginLeft: 10 }}>
                                <input className="form-check-input" type="radio" name="type2" id="type2" checked={data.dateType == "DELIVERED"} onChange={e => {
                                    updateData('dateType', "DELIVERED")
                                }} />
                                <label className="form-check-label" htmlFor="type2">DELIVERY DATE</label>
                            </div>
                        </div>
                        
                        
                    </div>
                    <div className="col" style={(data.isMonthWise == 0) ? { display: "" } : { display: "none" }}>
                        <label>Start Date</label>
                        <input type="date" className="form-control" value={data.StartDate} onChange={(e) => updateData('StartDate', e.target.value)} />
                    </div>
                    <div className="col" style={(data.isMonthWise == 0) ? { display: "" } : { display: "none" }}>
                        <label>End Date</label>
                        <input type="date" className="form-control" value={data.EndDate} onChange={(e) => updateData('EndDate', e.target.value)} />
                    </div>
                    <div className="col" style={(data.isMonthWise == 1) ? { display: "" } : { display: "none" }}>
                        <label>Year</label>
                        <select type="date" className="form-select" value={data.Year} onChange={(e) => updateData('Year', e.target.value)}>
                            <option value={year}>{year}</option>
                            <option value={year - 1}>{year - 1}</option>
                            <option value={year - 2}>{year - 2}</option>
                        </select>
                    </div>
                    <div className="col" style={(data.isMonthWise == 1) ? { display: "" } : { display: "none" }}>
                        <label>Month</label>
                        <select type="date" className="form-select" value={data.Month} onChange={(e) => updateData('Month', e.target.value)}>
                            <option value={1}>January</option>
                            <option value={2}>February</option>
                            <option value={3}>March</option>
                            <option value={4}>April</option>
                            <option value={5}>May</option>
                            <option value={6}>June</option>
                            <option value={7}>July</option>
                            <option value={8}>August</option>
                            <option value={9}>September</option>
                            <option value={10}>October</option>
                            <option value={11}>November</option>
                            <option value={12}>December</option>
                        </select>
                    </div>
                    <div className="col">
                        <button type="button" className="btn btn-primary" disabled={loading} style={{ marginTop: '1.3rem' }} onClick={onSearch}>
                            {loading ? <img src={Loader} height="30" /> : 'Search'}
                        </button>
                    </div>
                </div>

                {
                originalGrid && originalGrid.length > 0 &&
                <div className="row mt-3 pb-2">
                    <div className="col-12">
                        <div className='row'>
                            <div className="col-lg col-lg-12" style={{ textAlign: 'right' }}>
                                {/* <ExportExcelQSR data={originalGrid} /> */}
                               <ExportExcelButton data={originalGrid} columns={qsrOnicColumns} fileName="QSR-OnicReport"/>

                            </div>
                        </div>
                        
                        <br />
                        <Pagination
                            setGrid={setGrid}
                            searchObjInit={searchObjInit}
                            searchObject={searchObject}
                            originalGrid={originalGrid}
                            setPage={setPage}
                            setPageLimit={setPageLimit}
                            requestSort={requestSort}
                            sortConfig={sortConfig}
                            updateSearchData={updateSearchData}
                            sortedArray={sortedArray}
                            data={data}
                            dataCount={grid.length}
                            pageLimit={pageLimit}  
                            gridKeys={gridKeys}
                            page={page}
                            grid={
                                sortedArray && sortedArray.length > 0 && sortedArray.map((x, index) =>
                                    <Fragment key={index}>
                                        <tr key={index}>
                                            <td>{(index + 1)+(page*pageLimit)}</td>
                                            <td><span style={{ color: '#EA5B0C', cursor: 'pointer' }} onClick={(e) => {
                                                e.preventDefault();
                                                sessionStorage.setItem('cn', x.consignmentNumber);
                                                window.open('/cplight/tracking_2', '_blank');
                                            }}>{x.consignmentNumber}</span></td>
                                            <td>{x.accountNo}</td>
                                            <td style={{ minWidth: 300 }}>{x.LocationName}</td>
                                            <td>{x.BookingDate}</td>
                                            <td>{x.ArrivalDate}</td>
                                            <td>{x.OrgZone}</td>
                                            <td>{x.OrgBranch}</td>
                                            <td>{x.consignee}</td>
                                            <td>{x.consigneePhoneNo}</td>
                                            <td><SeeMoreModal detail={x.consigneeAddress} maxLength={60} /></td>                                            
                                            <td>{x.orderRefNo}</td>
                                            <td>{x.service}</td>
                                            <td>{x.destzone}</td>
                                            <td>{x.destbranch}</td>
                                            <td>{x.weight}</td>
                                            <td>{x.receivedBy}</td>
                                            <td>{x.time}</td>
                                            <td>{x.deliveryDate}</td>
                                            <td>{x.CODAmount}</td>
                                            <td style={{ minWidth: 150 }}>{x.RRStatus}</td>
                                            <td>{x.NCIReason}</td>
                                            <td>{x.PaymentMode}</td>
                                            <td>{x.paymentId}</td>
                                            <td>{x.InstrumentNumber}</td>
                                            <td>{x.totalAmount}</td>
                                            <td>{x.GST}</td>
                                            <td>{x.Attempts}</td>
                                            <td>{x.MSISDN}</td>
                                            <td>{x.onic_deliveryDate}</td>
                                            <td>{x.deliveryType}</td>
                                            <td  style={{ minWidth: 150 }}>{x.timeSlot}</td>
                                            <td  style={{ minWidth: 150 }}>{x.ICCID}</td>
                                        </tr>
                                    </Fragment>
                                )
                            }
                        />
                    </div>
                </div>
            }
            </div>
        </section>
}

export default QSR;